import { useState, useEffect } from "react";

/**
 * Custom hook to manage temporary feedback messages with severity
 * @param {number} [duration=1500] - Duration in milliseconds the message should be displayed
 * @returns {[{message: string | null, severity: string | null}, (message: string | null, severity?: string | null) => void]}
 * - Tuple of current feedback object and setter function
 */
export const useFeedback = (duration = 1500) => {
  const [feedback, setFeedback] = useState({ message: null, severity: null });

  useEffect(() => {
    if (feedback.message) {
      const timer = setTimeout(() => {
        setFeedback({ message: null, severity: null });
      }, duration);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [feedback, duration]);

  /**
   * Show a feedback message with optional severity
   * @param {string | null} message - Feedback message
   * @param {string | null} [severity="info"] - Severity type ("success", "error", "warning", "info")
   */
  const showFeedback = (message, severity = "info") => {
    setFeedback({ message, severity });
  };

  return [feedback, showFeedback];
};
